// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `h3 {
  margin-top: 25px;
  margin-bottom: 15px;
}

input[type=text] {
  border: 0;
  padding: inherit;
  width: 100%;
}

.accntInfo table tr td label:not(.likeSpan) {
  font-size: 14px;
  margin-bottom: auto;
}

.accntInfo table tr td:nth-child(2) {
  padding-left: 5px;
}

.tests20PercWidth {
  float: left;
  width: 20%;
}

.testsRightPad {
  padding-right: 15px;
}

.accntInfo table tr td {
  padding-top: 12px;
}

.bdown {
  box-sizing: border-box;
  border-bottom: 1px solid #EDF2F5;
  padding-bottom: 2px;
}

tr.actionModify {
  margin-bottom: 8px;
}

tr.actionModify td {
  border-bottom: 1px solid #EDF2F5;
  padding-bottom: 2px;
}

tr.actionModify td:nth-child(2) {
  padding-right: 15px;
}

tr.actionModify td:last-child {
  width: auto;
  vertical-align: middle;
}

select {
  background-color: white;
  width: 100%;
  border: 0;
  border-radius: 0;
  padding: 0;
}

select option {
  padding-left: 0;
}

tr.actionModify td:first-child {
  width: 150px;
}

tr.actionModify td:last-child div.editable {
  display: none;
}

tr.actionModify:hover td:last-child div.editable {
  display: block;
  cursor: pointer;
}

tr.actionModify:hover td:last-child div.editable div.editableIcon {
  height: 16px;
  width: 16px;
  background: url(/assets/administration/pencil-tool.png) no-repeat;
}

tr.actionModify:hover td:last-child div.editable div.editableIcon:hover {
  background: url(/assets/administration/pencil-tool_on.png) no-repeat;
}

tr.modifyButtons td {
  padding-top: 0 !important;
}

tr.modifyButtons td div.edit {
  text-align: right;
}

tr.modifyButtons td div.edit div.saveText,
tr.modifyButtons td div.edit div.cancelText {
  cursor: pointer;
}

tr.modifyButtons td div.edit div.saveText {
  color: #007566;
}

tr.actionModify td:last-child div.edit div.cancelText {
  cursor: pointer;
}

tr.modifyButtons td.modifyEnabled:nth-child(2), tr.actionModify td.modifyEnabled {
  border-bottom: 2px solid #007566;
}

tr.actionModify td.splitLineTile:after {
  content: ""; /* This is necessary for the pseudo element to work. */
  display: block; /* This will put the pseudo element on its own line. */
  margin: 0 0 -3px; /* This will center the border. */
  width: 15%; /* Change this to whatever width you want. */
  padding-top: 0; /* This creates some space between the element and the border. */
  border-bottom: 2px solid #007566;
  /* This creates the border. Replace black with whatever color you want. */
}

div.col-md-6 {
  padding-left: 0;
}

#pageHead {
  width: 100%;
  background-color: #F4F4F4;
  margin: 0;
  height: 50px;
}

.modalButton {
  background-color: white;
  color: #111111;
}

.modalButton:hover {
  background-color: #EDF2F5;
}

.datePicker ::ng-deep my-date-picker ::ng-deep .mydp {
  border: 0;
}

.datePicker ::ng-deep my-date-picker ::ng-deep .datePicker {
  padding: 0;
}

.datePicker ::ng-deep my-date-picker ::ng-deep .mydp .selector:focus {
  border: 1px solid #BABABA !important;
}

.datePicker ::ng-deep my-date-picker ::ng-deep .mydp .selector {
  border: 1px solid #BABABA !important;
}

.datePicker ::ng-deep my-date-picker ::ng-deep .mydp .selectorarrow:before {
  border: none !important;
}

.datePicker ::ng-deep my-date-picker ::ng-deep .mydp .selectorarrow:focus:before {
  border: none !important;
}

.datePicker ::ng-deep my-date-picker ::ng-deep .mydp .daycell:hover .prevmonth,
.datePicker ::ng-deep my-date-picker ::ng-deep .mydp .daycell:hover .nextmonth {
  color: #111111;
}

.datePicker ::ng-deep my-date-picker ::ng-deep .mydp .currmonth .sunday,
.datePicker ::ng-deep my-date-picker ::ng-deep .mydp .sundayDim {
  color: #999 !important;
}

.datePicker ::ng-deep my-date-picker ::ng-deep .mydp .selectedday {
  border: 1px solid #686868;
  background-color: #BABABA;
  color: black;
}

.datePicker ::ng-deep my-date-picker ::ng-deep .mydp .selectedday div {
  background-color: #BABABA !important;
  color: black;
  border: none !important;
}

.datePicker ::ng-deep my-date-picker ::ng-deep .mydp .headertodaybtn {
  border-radius: 0 !important;
}

.datePicker ::ng-deep my-date-picker ::ng-deep .mydp .caltable,
.datePicker ::ng-deep my-date-picker ::ng-deep .mydp .daycell,
.datePicker ::ng-deep my-date-picker ::ng-deep .mydp .weekdaytitle {
  color: #111111;
}

.datePicker ::ng-deep my-date-picker ::ng-deep .mydp .mydpicon:hover,
.datePicker ::ng-deep my-date-picker ::ng-deep .mydp .mydpicon:focus,
.datePicker ::ng-deep my-date-picker ::ng-deep .mydp .btnpicker:hover,
.datePicker ::ng-deep my-date-picker ::ng-deep .mydp .btnpicker:focus {
  background-color: white !important;
}

.datePicker ::ng-deep my-date-picker ::ng-deep .mydp .btnclear:hover,
.datePicker ::ng-deep my-date-picker ::ng-deep .mydp .btnclear:focus,
.datePicker ::ng-deep my-date-picker ::ng-deep .mydp .mydpicon:hover,
.datePicker ::ng-deep my-date-picker ::ng-deep .mydp .daycell:hover,
.datePicker ::ng-deep my-date-picker ::ng-deep .mydp .headertodaybtn:hover {
  background-color: #CCC;
}

.datePicker ::ng-deep my-date-picker ::ng-deep .mydp .headerbtn:hover,
.datePicker ::ng-deep my-date-picker ::ng-deep .mydp .headerlabelbtn:hover {
  color: #CCC;
}

.datePicker ::ng-deep my-date-picker ::ng-deep .mydp .icon-mydpleft:hover,
.datePicker ::ng-deep my-date-picker ::ng-deep .mydp .icon-mydpright:hover {
  color: #111111;
}

.datePicker ::ng-deep my-date-picker ::ng-deep .mydp .icon-mydpleft:focus,
.datePicker ::ng-deep my-date-picker ::ng-deep .mydp .icon-mydpright:focus {
  color: #999;
}

.datePicker ::ng-deep my-date-picker ::ng-deep .mydp .selection {
  font-size: 9pt !important;
  height: auto !important;
  padding: 0 !important;
  margin-top: 3px !important;
}

.datePicker ::ng-deep my-date-picker ::ng-deep .selbtngroup {
  height: auto !important;
}

.datePicker ::ng-deep my-date-picker ::ng-deep .selbtngroup .btnclear {
  height: auto;
  padding: 0;
}

.datePicker ::ng-deep my-date-picker ::ng-deep .selbtngroup .btnpicker {
  height: auto;
  padding: 0;
}

.Margin14px {
  margin: 14px;
}

.LeftMargin0Margin14px {
  margin: 14px 14px 14px 0;
}`, "",{"version":3,"sources":["webpack://./src/app/administration/components/administration-account/administration-account.component.scss"],"names":[],"mappings":"AACA;EACI,gBAAA;EACA,mBAAA;AAAJ;;AAGA;EACI,SAAA;EACA,gBAAA;EACA,WAAA;AAAJ;;AAGA;EACI,eAAA;EACA,mBAAA;AAAJ;;AAGA;EACI,iBAAA;AAAJ;;AAGA;EACI,WAAA;EACA,UAAA;AAAJ;;AAGA;EACI,mBAAA;AAAJ;;AAGA;EACI,iBAAA;AAAJ;;AAGA;EACI,sBAAA;EACA,gCAAA;EACA,mBAAA;AAAJ;;AAIA;EACI,kBAAA;AADJ;;AAIA;EACI,gCAAA;EACA,mBAAA;AADJ;;AAIA;EACI,mBAAA;AADJ;;AAIA;EACI,WAAA;EACA,sBAAA;AADJ;;AAIA;EACI,uBAAA;EACA,WAAA;EACA,SAAA;EACA,gBAAA;EACA,UAAA;AADJ;;AAIA;EACI,eAAA;AADJ;;AAKA;EACI,YAAA;AAFJ;;AAKA;EACI,aAAA;AAFJ;;AAKA;EACI,cAAA;EACA,eAAA;AAFJ;;AAKA;EACI,YAAA;EACA,WAAA;EACA,iEAAA;AAFJ;;AAKA;EACI,oEAAA;AAFJ;;AAKA;EACI,yBAAA;AAFJ;;AAKA;EACI,iBAAA;AAFJ;;AAKA;;EAEI,eAAA;AAFJ;;AAKA;EACI,cAAA;AAFJ;;AAKA;EACI,eAAA;AAFJ;;AAKA;EACI,gCAAA;AAFJ;;AAKA;EACI,WAAA,EAAA,sDAAA;EACA,cAAA,EAAA,sDAAA;EACA,gBAAA,EAAA,iCAAA;EACA,UAAA,EAAA,4CAAA;EACA,cAAA,EAAA,gEAAA;EACA,gCAAA;EACA,yEAAA;AAFJ;;AAKA;EACI,eAAA;AAFJ;;AAKA;EACI,WAAA;EACA,yBAAA;EACA,SAAA;EACA,YAAA;AAFJ;;AAKA;EACI,uBAAA;EACA,cAAA;AAFJ;;AAKA;EACI,yBAAA;AAFJ;;AAKA;EACI,SAAA;AAFJ;;AAKA;EACI,UAAA;AAFJ;;AAKA;EACI,oCAAA;AAFJ;;AAKA;EACI,oCAAA;AAFJ;;AAKA;EACI,uBAAA;AAFJ;;AAKA;EACI,uBAAA;AAFJ;;AAKA;;EAEI,cAAA;AAFJ;;AAKA;;EAEI,sBAAA;AAFJ;;AAKA;EACI,yBAAA;EACA,yBAAA;EACA,YAAA;AAFJ;;AAKA;EACI,oCAAA;EACA,YAAA;EACA,uBAAA;AAFJ;;AAKA;EACI,2BAAA;AAFJ;;AAKA;;;EAGI,cAAA;AAFJ;;AAKA;;;;EAII,kCAAA;AAFJ;;AAKA;;;;;EAKI,sBAAA;AAFJ;;AAKA;;EAEI,WAAA;AAFJ;;AAKA;;EAEI,cAAA;AAFJ;;AAKA;;EAEI,WAAA;AAFJ;;AAKA;EACI,yBAAA;EACA,uBAAA;EACA,qBAAA;EACA,0BAAA;AAFJ;;AAKA;EACI,uBAAA;AAFJ;;AAKA;EACI,YAAA;EACA,UAAA;AAFJ;;AAKA;EACI,YAAA;EACA,UAAA;AAFJ;;AAKA;EACI,YAAA;AAFJ;;AAKA;EACI,wBAAA;AAFJ","sourcesContent":["$admin-assets: #{\"/assets/administration/\"};\nh3 {\n    margin-top: 25px;\n    margin-bottom: 15px;\n}\n\ninput[type=text] {\n    border: 0;\n    padding: inherit;\n    width: 100%;\n}\n\n.accntInfo table tr td label:not(.likeSpan) {\n    font-size: 14px;\n    margin-bottom: auto;\n}\n\n.accntInfo table tr td:nth-child(2) {\n    padding-left: 5px;\n}\n\n.tests20PercWidth {\n    float: left;\n    width: 20%;\n}\n\n.testsRightPad {\n    padding-right: 15px;\n}\n\n.accntInfo table tr td {\n    padding-top: 12px;\n}\n\n.bdown {\n    box-sizing: border-box;\n    border-bottom: 1px solid #EDF2F5;\n    padding-bottom: 2px;\n}\n\n\ntr.actionModify {\n    margin-bottom: 8px;\n}\n\ntr.actionModify td {\n    border-bottom: 1px solid #EDF2F5;\n    padding-bottom: 2px;\n}\n\ntr.actionModify td:nth-child(2) {\n    padding-right: 15px;\n}\n\ntr.actionModify td:last-child {\n    width: auto;\n    vertical-align: middle;\n}\n\nselect {\n    background-color: white;\n    width: 100%;\n    border: 0;\n    border-radius: 0;\n    padding: 0;\n}\n\nselect option {\n    padding-left: 0;\n}\n\n\ntr.actionModify td:first-child {\n    width: 150px;\n}\n\ntr.actionModify td:last-child div.editable {\n    display: none;\n}\n\ntr.actionModify:hover td:last-child div.editable {\n    display: block;\n    cursor: pointer;\n}\n\ntr.actionModify:hover td:last-child div.editable div.editableIcon {\n    height: 16px;\n    width: 16px;\n    background: url($admin-assets + 'pencil-tool.png') no-repeat;\n}\n\ntr.actionModify:hover td:last-child div.editable div.editableIcon:hover {\n    background: url($admin-assets + 'pencil-tool_on.png') no-repeat;\n}\n\ntr.modifyButtons td {\n    padding-top: 0 !important;\n}\n\ntr.modifyButtons td div.edit {\n    text-align: right;\n}\n\ntr.modifyButtons td div.edit div.saveText,\ntr.modifyButtons td div.edit div.cancelText {\n    cursor: pointer;\n}\n\ntr.modifyButtons td div.edit div.saveText {\n    color: #007566;\n}\n\ntr.actionModify td:last-child div.edit div.cancelText {\n    cursor: pointer;\n}\n\ntr.modifyButtons td.modifyEnabled:nth-child(2), tr.actionModify td.modifyEnabled {\n    border-bottom: 2px solid #007566;\n}\n\ntr.actionModify td.splitLineTile:after {\n    content: \"\"; /* This is necessary for the pseudo element to work. */\n    display: block; /* This will put the pseudo element on its own line. */\n    margin: 0 0 -3px; /* This will center the border. */\n    width: 15%; /* Change this to whatever width you want. */\n    padding-top: 0; /* This creates some space between the element and the border. */\n    border-bottom: 2px solid #007566;\n    /* This creates the border. Replace black with whatever color you want. */\n}\n\ndiv.col-md-6 {\n    padding-left: 0;\n}\n\n#pageHead {\n    width: 100%;\n    background-color: #F4F4F4;\n    margin: 0;\n    height: 50px;\n}\n\n.modalButton {\n    background-color: white;\n    color: #111111;\n}\n\n.modalButton:hover {\n    background-color: #EDF2F5;\n}\n\n.datePicker ::ng-deep my-date-picker ::ng-deep .mydp {\n    border: 0;\n}\n\n.datePicker ::ng-deep my-date-picker ::ng-deep .datePicker {\n    padding: 0;\n}\n\n.datePicker ::ng-deep my-date-picker ::ng-deep .mydp .selector:focus {\n    border: 1px solid #BABABA !important;\n}\n\n.datePicker ::ng-deep my-date-picker ::ng-deep .mydp .selector {\n    border: 1px solid #BABABA !important;\n}\n\n.datePicker ::ng-deep my-date-picker ::ng-deep .mydp .selectorarrow:before {\n    border: none !important;\n}\n\n.datePicker ::ng-deep my-date-picker ::ng-deep .mydp .selectorarrow:focus:before {\n    border: none !important;\n}\n\n.datePicker ::ng-deep my-date-picker ::ng-deep .mydp .daycell:hover .prevmonth,\n.datePicker ::ng-deep my-date-picker ::ng-deep .mydp .daycell:hover .nextmonth {\n    color: #111111;\n}\n\n.datePicker ::ng-deep my-date-picker ::ng-deep .mydp .currmonth .sunday,\n.datePicker ::ng-deep my-date-picker ::ng-deep .mydp .sundayDim {\n    color: #999 !important;\n}\n\n.datePicker ::ng-deep my-date-picker ::ng-deep .mydp .selectedday {\n    border: 1px solid #686868;\n    background-color: #BABABA;\n    color: black\n}\n\n.datePicker ::ng-deep my-date-picker ::ng-deep .mydp .selectedday div {\n    background-color: #BABABA !important;\n    color: black;\n    border: none !important;\n}\n\n.datePicker ::ng-deep my-date-picker ::ng-deep .mydp .headertodaybtn {\n    border-radius: 0 !important;\n}\n\n.datePicker ::ng-deep my-date-picker ::ng-deep .mydp .caltable,\n.datePicker ::ng-deep my-date-picker ::ng-deep .mydp .daycell,\n.datePicker ::ng-deep my-date-picker ::ng-deep .mydp .weekdaytitle {\n    color: #111111;\n}\n\n.datePicker ::ng-deep my-date-picker ::ng-deep .mydp .mydpicon:hover,\n.datePicker ::ng-deep my-date-picker ::ng-deep .mydp .mydpicon:focus,\n.datePicker ::ng-deep my-date-picker ::ng-deep .mydp .btnpicker:hover,\n.datePicker ::ng-deep my-date-picker ::ng-deep .mydp .btnpicker:focus {\n    background-color: white !important;\n}\n\n.datePicker ::ng-deep my-date-picker ::ng-deep .mydp .btnclear:hover,\n.datePicker ::ng-deep my-date-picker ::ng-deep .mydp .btnclear:focus,\n.datePicker ::ng-deep my-date-picker ::ng-deep .mydp .mydpicon:hover,\n.datePicker ::ng-deep my-date-picker ::ng-deep .mydp .daycell:hover,\n.datePicker ::ng-deep my-date-picker ::ng-deep .mydp .headertodaybtn:hover {\n    background-color: #CCC;\n}\n\n.datePicker ::ng-deep my-date-picker ::ng-deep .mydp .headerbtn:hover,\n.datePicker ::ng-deep my-date-picker ::ng-deep .mydp .headerlabelbtn:hover {\n    color: #CCC\n}\n\n.datePicker ::ng-deep my-date-picker ::ng-deep .mydp .icon-mydpleft:hover,\n.datePicker ::ng-deep my-date-picker ::ng-deep .mydp .icon-mydpright:hover {\n    color: #111111\n}\n\n.datePicker ::ng-deep my-date-picker ::ng-deep .mydp .icon-mydpleft:focus,\n.datePicker ::ng-deep my-date-picker ::ng-deep .mydp .icon-mydpright:focus {\n    color: #999\n}\n\n.datePicker ::ng-deep my-date-picker ::ng-deep .mydp .selection {\n    font-size: 9pt !important;\n    height: auto !important;\n    padding: 0 !important;\n    margin-top: 3px !important;\n}\n\n.datePicker ::ng-deep my-date-picker ::ng-deep .selbtngroup {\n    height: auto !important;\n}\n\n.datePicker ::ng-deep my-date-picker ::ng-deep .selbtngroup .btnclear {\n    height: auto;\n    padding: 0;\n}\n\n.datePicker ::ng-deep my-date-picker ::ng-deep .selbtngroup .btnpicker {\n    height: auto;\n    padding: 0;\n}\n\n.Margin14px {\n    margin: 14px;\n}\n\n.LeftMargin0Margin14px {\n    margin: 14px 14px 14px 0;\n}\n\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
